define('plugin/tips/TipsPlugin',['require','backbone','lib/plugin/PluginAbstract','plugin/tips/view/TipsView','handlebars','lib/AppRouter'],function (require) {

    var Backbone = require('backbone');
    var PluginAbstract = require('lib/plugin/PluginAbstract');
    //var TipsCollection = require('plugin/tips/collection/TipsCollection');
    //var TipsModel = require('plugin/tips/model/TipsModel');
    var TipsView = require('plugin/tips/view/TipsView');
    // var TipsInvoiceInstanceListView = require('plugin/tips/view/TipsInvoiceInstanceListView');
    // var TipsServiceBadgeView = require('plugin/tips/view/TipsServiceBadgeView');
    // var TipsModuleListView = require('plugin/tips/view/TipsModuleListView');
    var Handlebars = require('handlebars');
    var AppRouter = require('lib/AppRouter');

    return PluginAbstract.extend({

        _collection: null,
        bookingModel: null,
        tipsModel: null,

        /**
         * Initializes plugin
         */
        initialize: function () {
            this.initCollection();
            this.initRoutes();
            this.initTemplateHelpers();
            this.subscribeInvoiceViewEvents();
        },

        /**
         * Initializes collection
         */
        initCollection: function () {
            //this._collection = new TipsCollection();
        },

        /**
         * On step manager inits, add events
         */
        initStepManagerEvents: function () {
            this.bookingModel = this._stepManager.getBookingModel();
        },

        /**
         * Initialize plugin modules
         */
        initModules: function (layout) {

        },


        /**
         * Subscribe to show tips view
         */
        subscribeInvoiceViewEvents: function () {
            Backbone.Wreqr.radio.channel('invoice:layout').vent.on(
                'show', _.bind(this.onInvoiceLayoutShow, this)
            );
        },

        /**
         * Display tips
         */
        onInvoiceLayoutShow: function (data) {
            var layout = data.view;
            var model = data.model;

            //console.log(data);

            if (data.paymentAllowed && this._allowToShowTips(model)) {
                var view = new TipsView({
                    model: model
                });

                if (Config.getInstance().getOption('apply_tips')) {
                    model.applyTips(Config.getInstance().getOption('apply_tips'));
                }

                this.listenTo(view, 'apply:tips', this.applyTips);
                this.listenTo(view, 'apply:custom:tips', this.applyCustomTips);

                layout.getTipsRegion().show(view);
            }
            //
            // var listView = new TipsInvoiceInstanceListView({
            //     model: model,
            //     collection: model.get('tips_instances'),
            //     allowEdit: data.paymentAllowed && model.get('status') === 'new'
            // });
            //
            // this.listenTo(listView, 'remove:tips', this.removeTips);
            //
            // layout.getTipsListRegion().show(listView);
        },

        _allowToShowTips: function (model) {
            var allow = false;
            if (model.get('status') === 'paid') {
                var isDelay = false;
                if (model.get('payment_processor') && model.get('payment_processor') === 'delay' && !model.get('payment_received')) {
                    isDelay = true;
                }
                if (!isDelay) {
                    return false;
                }
            } else if (model.get('status') !== 'new') {
                return false;
            }
            if (model.get('rest_amount') > 0) {
               // return false;
            }
            model.get('lines').each(function (model) {
                if (model.get('type') === 'tip' || model.get('type') === 'booking') {
                    allow = true;
                }
                if(model.get('type') === 'deposit' && model.get('booking_ids') && model.get('booking_ids').length > 0){
                    allow = true;
                }
            }, this);

            return allow;
        },

        /**
         * Applies tips
         *
         * @param model
         * @param percent
         */
        applyTips: function (model, percent) {
            model.applyTips(percent);
        },


        applyCustomTips: function (model, amount) {
            model.applyTips(null, amount);
        },

        /**
         * Remove tips
         *
         * @param invoiceModel
         * @param instanceModel
         */
        removeTips: function (invoiceModel, instanceModel) {
            invoiceModel.removeTips(instanceModel.get('id'));
        },

        /**
         * Inits tips routes
         */
        initRoutes: function () {

        },

        initTemplateHelpers: function () {

        }

    });

});
